import * as Actions from './products.actions';
import * as GridActions from './grid/product.grid.actions';
import { APP_INITIALIZATION } from '../core/base-actions';

const initialState = {
  productProfiles: [],
  shouldUseAggregateInventory: false,
  importLogModalOpen: false,
  importErrors: [],
  importProductsStarted: false,
  importProductsComplete: false,
  exportProductsStarted: false,
  exportProductsComplete: false,
};

const actionMap = {
  [Actions.PRODUCT_DETAILS_MODAL_OPEN]: (state) => {
    return {
      ...state,
      productDetailsIsLoading: true,
    };
  },
  [Actions.GET_PRODUCT_DETAILS_SUCCESS]: (state, action) => {
    const { productData } = action.payload;
    return {
      ...state,
      productId: productData.productId,
      productDetailsIsLoading: false,
    };
  },
  [APP_INITIALIZATION]: (state, action) => {
    const { productProfiles } = action.initialData;
    return {
      ...state,
      productProfiles,
    };
  },
  [Actions.GET_PRODUCT_PROFILES_SUCCESS]: (state, action) => {
    const { productProfiles } = action.payload;
    return {
      ...state,
      productProfiles,
    };
  },
  [Actions.UPDATE_PRODUCT]: (state) => {
    return {
      ...state,
      productDetailsIsLoading: true,
    };
  },
  [Actions.UPDATE_PRODUCT_SUCCESS]: (state) => {
    return {
      ...state,
      productDetailsIsLoading: false,
    };
  },
  [Actions.UPDATE_PRODUCT_FAILURE]: (state) => {
    return {
      ...state,
      productDetailsIsLoading: false,
    };
  },
  [Actions.SET_SHOULD_USE_AGGREGATE_INVENTORY]: (state, action) => {
    const { shouldUseAggregateInventory } = action;
    return {
      ...state,
      shouldUseAggregateInventory,
    };
  },
  [GridActions.IMPORT_PRODUCTS_REQUEST]: (state) => {
    return {
      ...state,
      importProductsStarted: true,
      importProductsComplete: false,
    };
  },
  [Actions.GET_PRODUCT_IMPORT_LOG]: (state) => {
    return {
      ...state,
      importProductsStarted: true,
      importProductsComplete: false,
    };
  },
  [Actions.GET_PRODUCT_IMPORT_SUCCESS]: (state) => {
    return {
      ...state,
      importProductsStarted: false,
      importProductsComplete: true,
    };
  },
  [Actions.GET_PRODUCT_IMPORT_LOG_PARTIAL_SUCCESS]: (state, action) => {
    const { importErrors } = action;
    return {
      ...state,
      importLogModalOpen: true,
      importErrors,
      importProductsStarted: false,
      importProductsComplete: true,
    };
  },
  [Actions.CLEAR_PRODUCT_IMPORT_LOG]: (state) => {
    return {
      ...state,
      importLogModalOpen: false,
      importErrors: [],
      importProductsStarted: false,
      importProductsComplete: true,
    };
  },
  [GridActions.EXPORT_PRODUCTS_REQUEST]: (state) => {
    return {
      ...state,
      exportProductsStarted: true,
      exportProductsComplete: false,
    };
  },
  [Actions.GET_PRODUCT_EXPORT_SUCCESS]: (state) => {
    return {
      ...state,
      exportProductsStarted: false,
      exportProductsComplete: true,
    };
  },
};

export const reduce = (state = initialState, action = {}) => {
  const reducer = actionMap[action.type];
  if (reducer) {
    return reducer(state, action);
  }

  return state;
};

export { namespace } from './products.reducer.metadata';
